/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import NavigationBar from '../layout/NavigationBar';
import { Container, Row, Col } from 'reactstrap';
import MiniListing from './MiniListing';
import SideBar from '../auth/SideBar';

import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';

import { executeTrade, deleteNotification } from '../../store/actions/marketActions';
import Notification from './Notification';

import '../../css/Market.css'
import '../../style.scss';

class Market extends Component {
    state = {
        activeNotifications: 0,
        newNotification: false,
        marketView: true,
        company: 0,
    };

    view = (company, marketViewable) => {
        this.setState({
            marketView: marketViewable,
            company
        });
    }
    
    removeNotification = (information) => {
        document.title = "Building Block Trade | Trading Platform for D-Trade";
        this.props.deleteNotification(information);
    }

    render() {
        if(this.props.companies) {
            if(!this.state.marketView) {
                return <Redirect push to={ "market/" + this.props.companies[this.state.company].id }/>
            }
        }
        
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to="/welcome" />;
        
        let listings = [<h4 key={0} style={{color:'white', marginTop:10}}>Loading...</h4>];

        if(this.props.companies) {
            listings = [];

            let j = 0;
            
            while(j < this.props.companies.length) {
                const c = [this.props.companies[j], this.props.companies[j + 1]];

                let first = '';
                let second = '';

                if(c[0] !== undefined) {
                    first = <MiniListing 
                    name={c[0].id} 
                    price={parseFloat(c[0].price)} 
                    prevPrice={parseFloat(c[0].prevPrice)}
                    view={this.view} position={j}
                    bestBid={c[0].bestBid}
                    bestBidAmount={c[0].bestBidAmount}
                    bestAsk={c[0].bestAsk}
                    bestAskAmount={c[0].bestAskAmount}
                    priceData={c[0].priceHistory} />;
                }

                if(c[1] !== undefined) {
                    second = <MiniListing 
                    name={c[1].id} 
                    price={parseFloat(c[1].price)} 
                    prevPrice={parseFloat(c[1].prevPrice)} 
                    view={this.view} position={j + 1}
                    bestBid={c[1].bestBid}
                    bestBidAmount={c[1].bestBidAmount}
                    bestAsk={c[1].bestAsk}
                    bestAskAmount={c[1].bestAskAmount}
                    priceData={c[1].priceHistory} />
                }

                listings.push(
                    <Row key={j}>
                        <Col style={{ padding: 0, paddingRight: 15 }}>
                            { first }
                        </Col>
                        <Col style={{ padding: 0, paddingRight: 15 }}>
                            { second }
                        </Col>
                    </Row>
                );
                
                j += 2;
            }
        }

        let notifications = [];

        if (this.props.notifications && this.props.notifications.length > 0) {
            const information = this.props.notifications[0].notifications;

            for (const key in information) {
                const item = information[key];

                if(!item.viewed) {
                    notifications.push(<Notification key={key} deleteNotification={this.removeNotification} information={item} tradeValue="987,654" /> )
                }

                document.title = "(" + notifications.length + ") Building Block Trade | Trading Platform for D-Trade";
            }
        }

        return (
            <div className={ 'darkMarket' } >
                <NavigationBar activeTab="market" />
                {notifications}
                <div id="page-wrap" className="container" style={{ maxWidth: 1300 }}>
                    <div className="action">
                        <div className="title market_title">
                            <h2>Market</h2>
                            <div className="market_state">
                                <h4 className="open">Open</h4>
                            </div>
                        </div>
                        <div className="metrics shares_only"></div>
                    </div>
                    <Container style={{ maxWidth: 1300 }}>
                        <Row xs="1">
                            <Col className="market" md="9" lg="9">
                                {listings}
                            </Col>
                            <SideBar />
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        executeTrade: (information) => dispatch(executeTrade(information)),
        deleteNotification: (information) => dispatch(deleteNotification(information)),
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        companies: state.firestore.ordered.companies,
        notifications: state.firestore.ordered.notifications,
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        return [
            { collection: 'companies' },
            { collection: 'notifications', doc: props.auth.uid }]
    })
)(Market);